import { EmptyState } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";
import { AIAgentPromptCard } from "app/pages/sales-intelligence/modules/ai-agent/components/AIAgentPromptCard";
import { AIAgentPromptGroupContainer } from "app/pages/sales-intelligence/modules/ai-agent/containers/AIAgentPromptGroup";

import { StyledFiltersChat } from "../styles";

import { AiRetryButton } from "./AiRetryButton/AiRetryButton";
import { StyledAiErrorStateContainer } from "./styles";

type Props = {
    onRefresh?: VoidFunction;
};

export const AIAgentChatErrorView = ({ onRefresh }: Props) => {
    return (
        <>
            <StyledFiltersChat>
                <StyledAiErrorStateContainer>
                    <EmptyState
                        title={translate("si.common.something-went-wrong")}
                        iconName="no-data-lab"
                        CtaButtons={() => <AiRetryButton onRefresh={onRefresh} />}
                        subtitle={translate("si.filters.something-went-wrong.refresh-ai-filter")}
                    />
                </StyledAiErrorStateContainer>
            </StyledFiltersChat>

            <AIAgentPromptCard>
                <AIAgentPromptGroupContainer
                    isFocusTriggered={false}
                    isInputLocked
                    placeholder={translate("si.agent.leads.input.placeholder.text")}
                    onSubmit={() => null}
                />
            </AIAgentPromptCard>
        </>
    );
};
